
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component } from "vue-property-decorator";
import BgAvatarUploader from "@/components/bg-avatar-uploader/index.vue";
import { SupplierForm } from "@/service/supplier-meta/common/SupplierForm";
import { ElementUIFormRules } from "@/service/supplier-meta/common/supplier-field-ctrl";
import { Form } from "element-ui";
@Component({
  components: {
    BgAvatarUploader,
  },
})
export default class FactoryExaminingReport extends SupplierForm {
  form = {
    enterpriseInfo: {
      factoryExaminingReportPath: "",
    },
  };
  maxSize = 1024 * 1024 * 4;
  get rules(): ElementUIFormRules {
    return this.getFieldsRules(["enterpriseInfo.factoryExaminingReportPath"]);
  }
  getFormRef() {
    return this.$refs.form as Form;
  }
  getFormData() {
    return this.form;
  }
  handleUploadChange() {
    // 重新校验
    const form = this.getFormRef();
    form.validateField("enterpriseInfo.factoryExaminingReportPath");
  }
}
